import AodObject from './AodObject';
import Role from "../Role";
import {orderBy} from '../../lib/Utils';
import {pick, merge, omit, each, includes, findWhere, map, isObject} from "lodash";

// todo ?except and pass service down (use object factory?)
//  fix  aodItem/aodItemList  use
//  remove $ - use lodash / ?bluebird

export default function Project(record, aodService)
{
    AodObject.call(this, record, aodService, 'Project');

    //TBD - map or array
    //this.projectItems = this.projectItems ? utils.newObjectList(this.projectItems, ProjectItem) : {};
    this.projectItems = this.projectItems
        ? this.aodService.factory.getList('ProjectItem', this.projectItems )
        : {};
};

Project.prototype = Object.create(
    AodObject.prototype,
    {
        getSaveData: {
            value: function getSaveData()
            {
                var data = AodObject.prototype.getSaveData.call(this);
                return omit(data, ['projectItems', 'projectItemOrder', 'trashItems']);
            }
        },
        clone: {
            value: function clone(options)
            {
                const data = pick(this,['id', 'recordVersion', 'type', 'accountId']);
                const self = this;

                return this.aodService.itemCall.clone(this.id, data, options)
                    .then(function(response)
                    {
                        //return new aod.Project(response.project);
                        return self.aodService.factory('Project',response.project);
                    });
            }
        },
        copy: {
            value: function copy(newProject, options)
            {
                options = options||{};

                // newProject contains data to be appliaed to the copy - name , description , shares
                var data = pick( newProject, ['name','description','type','accountId']);
                data = merge(data, pick(this,['id', 'recordVersion']));
                if (!options.copyShares && newProject.targetedRoles)
                {
                    newProject = this.aodService.factory('Project',newProject);
                    data.changedRoles = Role.getDiff(newProject.getShares());
                }

                const self = this;
                return this.aodService.itemCall.copy(this.id, data, options)
                    .then(function(response)
                    {
                        return self.aodService.factory('Project',response.project);
                    });
            }
        },

        getThumbUrl: {
            value: function getThumbUrl(size)
            {
                var url = 'images/empty_folder.png' ;  //TBD default empty Project

                if (this.thumbUrl) {
                    url = this.thumbUrl;  // Cheating -stuffed whole url in
                }
                else if (this.metroName) {
                    //todo remove global mcc dependncy
                    //url = mcc.getUrl( 'thumb.jpg', {FILENAME: this.metroName});
                    url = this.aodService.getMccUrl( 'thumb.jpg', {FILENAME: this.metroName});
                }
                else if ( this.projectItemOrder && this.projectItemOrder.length)
                {
                    url = this.projectItems[this.projectItemOrder[0]].getThumbUrl();
                }

                return url;
            }
        },


        ///////////////////////
        // item functions
        //TBD itemList object (...from aodList)

        getItems: {
            value: function() {  //TBD ad sort options
                return orderBy(this.projectItems, this.projectItemOrder);
            }
        },

        createItem: { // return item
            value: function createItem(data)
            {
                if ( this.getItem(data.metroName) ) {
                    //return $.Deferred().resolve();
                    return Promise.resolve();
                }

                console.log('Adding: '+ data.metroName);
                //var projectItem =  new aod.ProjectItem(data);
                const projectItem = this.aodService.factory

                return projectItem.create(this);
                //TBD amedn items - minimal projects don't have them anyway
                //var self = this;
                /*
                then(function(item)
                {
                    this.projectItems[item.id] = item;
                    this.projectItemOrder.unshift(item.id);
                    this.itemCount = this.projectItemOrder.length;

                    return(item);
                });
                */
            }
        },
        createItems: {   // returns full project
            value: function createItems(list)
            {
                var data = pick(this,['id','recordVersion']);
                //var names = _.pluck(this.projectItems,'metroName');
                var names = map(this.projectItems,'metroName');

                data.projectItems = {};
                var i = 1;

                each(list, function(item)
                {
                    if (!includes(names,item.metroName)) {
                        data.projectItems[i++] = pick(item,['metroName','thumbUrl']);
                    }
                });

                var self = this;
                return this.aodService.itemCall.update(this.id, data)
                    .then(function(response)
                    {
                        return new self.constructor(response[self.item]);
                    });
            }
        },
        removeItem: {
            value: function removeItem(asset)
            {
                var name = isObject(asset) ? asset.file_name : asset ;

                var projectItem = this.getItem(name);
                if ( !projectItem ) {
                    //return $.Deferred().resolve('');
                    return Promise.resolve();
                }

                console.log('Removing: '+ name);
                return projectItem.remove();
                /*
                // var self = this;
                .then(function(item)
                {
                    delete this.projectItems[item.id];
                    this.projectItemOrder = _.without(this.projectItemOrder,item.id);
                    this.itemCount = this.projectItemOrder.length;

                    return(item);
                });
                */
            }
        },

        // todo - Clearly not supported yet
        /*
        restoreItem: {
            value: function restoreItem(name)
            {
                //TBD Check in trash
                var itemId;
                //TBD Check if name not already present
                var self = this;

                return aodItem.projectItem.restore(itemId)
                    .then( function(data)
                    {
                        return data;
                    })
                    .fail( function(error)
                    {
                        //miapp.alert(error.message, null,'Create SpecAd failed');
                        console.log('Restore projectItem failed');
                    });


            }
        },
*/

        canItem: {
            value: function(metroName,action)
            {
                //return this.can('edit') || (this.can('createProjectItem') && this.isMyItem(metroName));
                var item = this.getItem(metroName);
                return item ? item.can(action) : undefined ;
            }
        },
        getItem: {
            value: function(metroName)
            {
                return findWhere(this.projectItems,{metroName:metroName});
            }
        },

        loadTrashedItems: {
            value: function loadTrashedItems()
            {
                var self = this;

                //return aodItemList['projectItem'].trash(this.id, 'project', {})
                return this.aodService.itemCalls['projectItem'].trash(this.id, 'project', {})
                    .then( function(data)
                    {
                        self.trash = {'projectItemOrder':data.projectItemOrder};
                        //self.trash.projectItems = utils.newObjectList(data.projectItems,aod.ProjectItem);
                        self.trash.projectItems = self.factory.getList('ProjectItem', data.projectItems);
                        self.attachHistoryItems();

                        // todo not sure about this
                        //return aodItemList['projectItem'].getRecords(data);
                        return self.aodService.itemCalls['projectItem'].getRecords(data);
                    });
            }
        },

        //TBD make base function
        loadHistory: {
            value: function loadHistory()
            {
                var self = this;

                return this.aodService.itemCalls['history'].search(this.id, 'project', {includeNested:true})
                    .then( function(data)
                    {
                        self.history = self.factory.getList('History',data.history);
                        self.attachHistoryItems();
                        return self.history;
                    });
            }
        },

        attachHistoryItems: {
            value: function ()
            {
                function attachItems(entries, itemParent)
                {
                    if (!entries || !itemParent)
                        return;

                    each(entries, function(entry)
                    {
                        if (entry.projectItemId && !entry.projectItem && entry.projectItemId in itemParent.projectItems)
                            entry.projectItem = itemParent.projectItems[entry.projectItemId];
                    });
                }

                attachItems(this.history, this);
                attachItems(this.history, this.trash);
            }
        }

        //getters & setters

        // TBD used to ensure diff fires - server not increment version on project Item delete
        /* server does now
        itemCount: {
            get: function() {
                return this.projectItemOrder ? this.projectItemOrder.length : 0;
            },
            enumerable: true
        }
        */
    }
);

Project.prototype.constructor = Project;

